import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/cancel.svg'
import _imports_1 from '@/assets/editIcon.svg'
import _imports_2 from '@/assets/deleteIcon.svg'
import _imports_3 from '@/assets/correctIcon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-6369a7d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "maincontainer py-8 px-4 w-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title flex items-center" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Configurations")
  ])
], -1))
const _hoisted_3 = {
  key: 0,
  class: "card justify-center items-center flex mt-4"
}
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex flex-col w-full bg-white" }
const _hoisted_6 = { class: "p-5 border-b border-solid border-lightgrey rounded-t row flex w-full justify-between items-center" }
const _hoisted_7 = {
  key: 0,
  class: "formcontainer flex mr-2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Update Configuration", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "formcontainer flex mr-2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Create Configuration", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "statuscontainer p-2" }
const _hoisted_14 = { class: "formcontainer flex flex-col" }
const _hoisted_15 = { class: "row flex flex-row w-full" }
const _hoisted_16 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Configuration", -1))
const _hoisted_18 = { class: "flex bg-white py-2.5 px-2.5 text-lg rounded justify-between accordion-head" }
const _hoisted_19 = {
  key: 0,
  class: "title font-opensans text-lg cursor-pointer ml-1 flex"
}
const _hoisted_20 = ["for"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", { type: "text" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("textarea", { name: "Empty Field" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { key: 2 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", { type: "radio" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 3 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", { type: "checkbox" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { key: 4 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("select", null, [
  /*#__PURE__*/_createElementVNode("option", { value: "" }, "qqqq"),
  /*#__PURE__*/_createElementVNode("option", { value: "" }, "ww"),
  /*#__PURE__*/_createElementVNode("option", { value: "" }, "ee")
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  class: "my-2"
}
const _hoisted_37 = { class: "userPopup" }
const _hoisted_38 = {
  key: 0,
  class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex"
}
const _hoisted_39 = { class: "relative w-full max-w-xl" }
const _hoisted_40 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_41 = { class: "flex items-start justify-between p-3 rounded" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "User Details", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "p-2" }
const _hoisted_46 = { class: "text-black no-underline mt-0.5 min-h-30 cursor-pointer" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-t-2" }, null, -1))
const _hoisted_48 = { class: "p-2" }
const _hoisted_49 = { class: "controlSelection" }
const _hoisted_50 = { class: "w-1/2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Please select control type:", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Text-Box", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Text-Area", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Radio", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "CheckBox", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Dropdown", -1))
const _hoisted_58 = [
  _hoisted_52,
  _hoisted_53,
  _hoisted_54,
  _hoisted_55,
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_60 = {
  key: 0,
  class: "error-text"
}
const _hoisted_61 = { class: "controlMetaData flex mt-5" }
const _hoisted_62 = {
  key: 0,
  class: "w-3/5"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Label for control", -1))
const _hoisted_64 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_65 = {
  key: 0,
  class: "error-text"
}
const _hoisted_66 = {
  key: 1,
  class: "flex flex-col justify-center items-center w-1/5 ml-3"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm" }, "Mandatory", -1))
const _hoisted_68 = { class: "switch" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_70 = { class: "controlOptions flex mt-5" }
const _hoisted_71 = {
  key: 0,
  class: "w-1/2"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Option(s)", -1))
const _hoisted_73 = { class: "imgoptioncontainer" }
const _hoisted_74 = { class: "ml-2" }
const _hoisted_75 = { class: "flex" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = ["onClick"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-5 h-5"
}, null, -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = {
  key: 0,
  class: "gap-1.5 mt-6 ml-3"
}
const _hoisted_86 = { class: "flex justify-center" }
const _hoisted_87 = {
  key: 1,
  class: "opacity-40 fixed inset-0 z-50 bg-black"
}
const _hoisted_88 = {
  key: 1,
  class: "flex justify-end mb-4 items-end mr-4 mt-4"
}
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = {
  key: 1,
  class: "card justify-center items-center flex mt-4"
}
const _hoisted_92 = { class: "w-full" }
const _hoisted_93 = { class: "flex flex-col w-full bg-white" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex p-5 border-b border-solid border-lightgrey rounded-t" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "formcontainer flex mr-2" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Create Configuration")
  ])
], -1))
const _hoisted_95 = { class: "statuscontainer p-2" }
const _hoisted_96 = { class: "formcontainer flex flex-col" }
const _hoisted_97 = { class: "row flex flex-row w-full" }
const _hoisted_98 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Configuration:", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_101 = { class: "p-2" }
const _hoisted_102 = { class: "accordion-body bg-white" }
const _hoisted_103 = { class: "p-2" }
const _hoisted_104 = { class: "controlMetaData flex mt-5" }
const _hoisted_105 = { class: "w-1/2" }
const _hoisted_106 = { class: "controllabel font-normal text-sm mb-1" }
const _hoisted_107 = {
  key: 0,
  type: "text",
  class: "inputboxstyling"
}
const _hoisted_108 = { key: 0 }
const _hoisted_109 = {
  key: 0,
  type: "radio"
}
const _hoisted_110 = {
  key: 1,
  type: "checkbox"
}
const _hoisted_111 = { class: "ml-2 mb-2" }
const _hoisted_112 = { key: 1 }
const _hoisted_113 = { class: "inputboxstyling" }
const _hoisted_114 = { class: "flex justify-end mb-4 items-end mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      (_ctx.addData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.config._id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "btnprimary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addControlsToConfig()))
                    }, "Add Fields")
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "inputboxstyling",
                          placeholder: "Configuration",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.name) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.config.name]
                        ])
                      ])
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.controls, (control, controlIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "text-black no-underline mt-0.5 cursor-pointer p-2",
                    key: controlIndex
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      (control.controlType)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("label", {
                              for: control.controlType
                            }, _toDisplayString(control.label), 9, _hoisted_20),
                            (control.controlType == 'TextBox')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                              : _createCommentVNode("", true),
                            (control.controlType == 'TextArea')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                              : _createCommentVNode("", true),
                            (control.controlType == 'Radio')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                              : _createCommentVNode("", true),
                            (control.controlType == 'CheckBox')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                              : _createCommentVNode("", true),
                            (control.controlType == 'Dropdown')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128)),
                (_ctx.config.controls.length>0)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_36))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_37, [
                  (_ctx.showUserModal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _hoisted_42,
                              _createElementVNode("button", {
                                class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showUserModal = false))
                              }, _hoisted_44)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", null, [
                                  _hoisted_47,
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, [
                                        _hoisted_51,
                                        _withDirectives(_createElementVNode("select", {
                                          class: _normalizeClass(["inputboxstyling", {
																		'is-invalid': _ctx.v$.control.controlType.$error
																	}]),
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.control.controlType) = $event)),
                                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeTarget(_ctx.control)))
                                        }, _hoisted_58, 34), [
                                          [_vModelSelect, _ctx.control.controlType]
                                        ]),
                                        (_ctx.v$.control.controlType.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                              (_ctx.v$.control.controlType.required.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_60, "Required"))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_61, [
                                      (_ctx.control.controlType)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                            _hoisted_63,
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: _normalizeClass(["inputboxstyling", {
																		'is-invalid': _ctx.v$.control.label.$error
																	}]),
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.control.label) = $event))
                                            }, null, 2), [
                                              [_vModelText, _ctx.control.label]
                                            ]),
                                            (_ctx.v$.control.label.$error)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                  (_ctx.v$.control.label.required.$invalid)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, "Required"))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.control.controlType)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                            _hoisted_67,
                                            _createElementVNode("label", _hoisted_68, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.control.mandatory) = $event))
                                              }, null, 512), [
                                                [_vModelCheckbox, _ctx.control.mandatory]
                                              ]),
                                              _hoisted_69
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_70, [
                                      (_ctx.control.controlType == 'Radio' || _ctx.control.controlType == 'CheckBox' || _ctx.control.controlType == 'Dropdown')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                            _hoisted_72,
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "inputboxstyling",
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.control.option) = $event))
                                            }, null, 512), [
                                              [_vModelText, _ctx.control.option]
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.control.options, (option, optionIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "optionscontainer border rounded-sm border-lightgrey mt-2.5 p-1.5 text-black flex justify-between bg-darkslategrey min-h-30",
                                          key: option
                                        }, [
                                          _createElementVNode("div", _hoisted_73, [
                                            _createElementVNode("div", _hoisted_74, _toDisplayString(option.option), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_75, [
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.onOptionEdit(optionIndex))
                                            }, _hoisted_78, 8, _hoisted_76),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.onOptionDelete(optionIndex))
                                            }, _hoisted_81, 8, _hoisted_79),
                                            (_ctx.hideUpdateIcon)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  onClick: ($event: any) => (_ctx.onOptionUpdate(optionIndex))
                                                }, _hoisted_84, 8, _hoisted_82))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      }), 128)),
                                      (_ctx.control.controlType == 'Radio' || _ctx.control.controlType == 'CheckBox' || _ctx.control.controlType == 'Dropdown')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                            _createElementVNode("button", {
                                              class: _normalizeClass((_ctx.control.option == '' || _ctx.control.option == undefined)?'btndisabled pointer-events-none':'btnprimary'),
                                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addLabelsforInputControls(_ctx.control.option,_ctx.controlIndex)))
                                            }, "Add", 2)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_86, [
                                    (!_ctx.updateButton)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: _normalizeClass(["mb-4", _ctx.control.controlType == ''?'btndisabled pointer-events-none':'btnprimary']),
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveControl(_ctx.control)))
                                        }, "Save", 2))
                                      : _createCommentVNode("", true),
                                    (_ctx.updateButton)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "btnprimary mb-4",
                                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateControl(_ctx.controlIndex)))
                                        }, "Update"))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showUserModal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_87))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.config.controls.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      (_ctx.pageType == 'create')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                            _createElementVNode("button", {
                              class: _normalizeClass([_ctx.defNotEqual ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none', "ml-10 mr-10"]),
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.save()))
                            }, "Save", 2)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_90, [
                            _createElementVNode("button", {
                              class: _normalizeClass(_ctx.defNotEqual ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none'),
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.update()))
                            }, "update", 2)
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showPreview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("div", _hoisted_93, [
                _hoisted_94,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _hoisted_99,
                          _createTextVNode(" " + _toDisplayString(_ctx.config.name), 1)
                        ])
                      ])
                    ]),
                    _hoisted_100
                  ])
                ]),
                _createElementVNode("div", _hoisted_101, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.controls, (control, controlIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "text-black no-underline mt-0.5 min-h-30 cursor-pointer",
                      key: controlIndex
                    }, [
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("div", _hoisted_105, [
                              _createElementVNode("label", _hoisted_106, _toDisplayString(control.label), 1),
                              (control.controlType == 'TextBox' || control.controlType == 'TextArea')
                                ? (_openBlock(), _createElementBlock("input", _hoisted_107))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (control.controlType == 'Radio' || control.controlType == 'CheckBox')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.controls[controlIndex].options, (option) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "min-h-30",
                                    key: option
                                  }, [
                                    (control.controlType == 'Radio')
                                      ? (_openBlock(), _createElementBlock("input", _hoisted_109))
                                      : _createCommentVNode("", true),
                                    (control.controlType == 'CheckBox')
                                      ? (_openBlock(), _createElementBlock("input", _hoisted_110))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("label", _hoisted_111, _toDisplayString(option.option), 1)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (control.controlType == 'Dropdown')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                _createElementVNode("select", _hoisted_113, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.controls[controlIndex].options, (option) => {
                                    return (_openBlock(), _createElementBlock("option", { key: option }, _toDisplayString(option.option), 1))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("button", {
                      class: "btnprimary",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.close()))
                    }, "Close")
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}